module.exports = __webpack_public_path__ + "img/page1-bg-phone.5bddd047.png";